// extracted by css-extract-rspack-plugin
export default {"BetaLabel":"RegexField-module__BetaLabel__FXaAB","TestButton":"RegexField-module__TestButton__NLUIm"};